import React from "react";
import { useContext} from "react";
import { store } from "../Store";
import { useLanguageVisibility } from "./hooks/use-language-visibility";
import { useLanguage } from "../../hooks/use-language";
import { useLanguageSelection } from "../../hooks/use-language-selection";

/**
 * Rederiza el dropdown de lenguaje
 * @returns {React.Component}
 */
export const DropdownLang = () => {
    const storeContext = useContext(store);
    const appState = storeContext?.state;
    const language = useLanguage();
    const languageSelection = useLanguageSelection();
    const isVisible = appState?.languageDropdown?.visible;
    const languageVisibility = useLanguageVisibility();

    const updateLanguage = (lang) => {
        languageSelection.setLanguage({lang});
        localStorage.setItem('language', lang);
        if (languageVisibility.isVisible) {
            storeContext.dispatch({
                type: "CHANGE",
                path: "languageDropdown.visible",
                value: false,
            });
        }
    }

    return (
        <ul className={`dropdownLang  ${isVisible ? 'activeMode' : 'inactiveMode'} `} >
            <li className={`${isVisible ? 'activeMode' : 'inactiveMode'}`}>
                <button
                    className={`button focusable-red ${language === "es" ? "activeMode" : "inactiveMode"}`}
                    onClick={() => updateLanguage("es")}
                >
                    Español
                </button>
            </li>
            <li className={`${isVisible ? 'activeMode' : 'inactiveMode'}`}>
                <button
                    className={`button focusable-red ${language === "en" ? "activeMode" : "inactiveMode"}`}
                    onClick={() => updateLanguage("en")}
                >
                    English
                </button>
            </li>
        </ul>
    )
}